import styled from "styled-components";
import { TypeColorNames } from "../../../theme/colors";

export const Container = styled.footer`
  width: 100%;
  height: auto;
  justify-content: space-around;
  
  img {
    width: 22px;
  }
`;

type TypeWrapper = {
  background: TypeColorNames;
  textColor: TypeColorNames;
  fontSize: string;
  padding: string;
}

export const Wrapper = styled.div<TypeWrapper>`
  background-color: ${(props) => props.theme.colors[props.background]};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  font-size: ${(props) => props.fontSize};
  gap: 8px;
  padding: ${(props) => props.padding};

  ${(props) => props.theme?.mediaQuerie.maxWidth.sm}{
      padding: 24px 12px;
      gap: 18px;
      justify-content: center;
    }
    
    > div {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 12px;

    ${(props) => props.theme?.mediaQuerie.maxWidth.sm}{
      gap: 12px;
      justify-content: center;
    }

    p, a {
      margin: 0;
      color: ${(props) => props.theme.colors[props.textColor]};
      opacity: 0.8;
       
      &:hover {
        opacity: 1;
      }
    }

    a:hover {
      cursor: pointer;
    }

    button {
      border: none;
      background: transparent;
      padding: 0px 8px;
      &:hover {
        cursor: pointer;
      }
    }
  }
`;